import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      backgroundColor: palette.common.white,
      padding: '20px',
      borderRadius: palette.borderRadius.default
    },
    rootFlex: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    },
    flexPage: {
      display: 'flex',
      gap: '30px'
    },
    sidePanier: {
      backgroundColor: palette.common.white,
      padding: '25px',
      borderRadius: palette.borderRadius.default,
      height: 'auto',
      '@media (max-width:768px)': {
        marginBottom: '90px'
      }
    },
    disableMessage: {
      color: palette.danger.red,
      padding: '10px',
      fontWeight: 500
    },
    buttonAction: {
      display: 'flex',
      gap: '20px',
      margin: 'auto',
      '@media (max-width:768px)': {
        flexDirection: 'column'
      }
    },
    infoBlock: {
      height: '60vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    textContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
